<template>
  <v-card class="pa-4">
    <label class="label">Status projektu:</label>
    <div class="project-details-card__status">
      <AppStatus
        :status-text="project.status"
        :clickable="statusChangePermitted && !project.softDeleted && !disableStatusChange"
        @click="changeStatus"
      />
    </div>
    <v-stepper
      v-if="project.progressState"
      :value="project.progressState.state"
      elevation="0"
    >
      <v-stepper-header>
        <template v-for="i in 8">
          <ProjectStatusStep
            :key="'step' + i"
            :step="i.toString()"
          />
          <v-divider
            v-if="i !== 8"
            :key="'divider' + i"
          />
        </template>
      </v-stepper-header>
    </v-stepper>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import AppStatus from '@/components/UI/AppStatus.vue';
import ProjectStatusStep from '@/components/Projects/ProjectStatusStep.vue';

export default {
  props: {
    project: {
      type: Object,
      required: true,
    },
    disableStatusChange: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AppStatus,
    ProjectStatusStep,
  },
  computed: {
    ...mapGetters('auth', ['checkUserPermissions']),
    statusChangePermitted() {
      const availability = ['admin_director', 'chief'];
      return this.checkUserPermissions(availability);
    },
  },
  methods: {
    changeStatus() {
      this.$emit('changeStatus');
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .v-stepper {
    margin: 24px 0;
  }
  .v-stepper__header {
    height: 24px;
  }
  .v-stepper__step {
    padding: 0 24px;
  }
}
</style>
